import React from "react";

import { Stack, SxProps, Typography } from "@mui/material";

import TooltipWrapper from "@rui/TooltipWrapper";

interface RecommendationChipProps {
  fontColor: React.CSSProperties["color"];
  backgroundColor: React.CSSProperties["color"];
  label?: string;
  startIcon?: React.ReactNode;
  tooltip?: string;
  sx?: SxProps;
}

const RecommendationChip = ({
  fontColor,
  backgroundColor,
  label,
  startIcon,
  tooltip,
  sx,
}: RecommendationChipProps) => {
  return (
    <TooltipWrapper arrow title={tooltip} placement="bottom-start">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent={label ? "flex-start" : "center"}
        sx={{
          bgcolor: backgroundColor,
          color: fontColor,
          borderRadius: "8px",
          p: 0.5,
          width: "fit-content",
          height: "24px",
          minWidth: "24px",
          ...sx,
        }}
      >
        {startIcon}
        {label && (
          <Typography
            variant="labelMed"
            sx={{
              color: fontColor,
              ml: startIcon ? 0.5 : 0,
            }}
          >
            {label}
          </Typography>
        )}
      </Stack>
    </TooltipWrapper>
  );
};

export default RecommendationChip;
